import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SystemConstant } from "@/const";
import { ButtonStatusType, ButtonStatusUser } from "./StatusInternalRequest";

type StatusUserProps = {
  status: SystemConstant.STATE;
};

const StatusUser: FC<StatusUserProps> = ({ status }) => {
  const { t: getLabel } = useTranslation();

  const [btnStatus, setBtnStatus] = useState<ButtonStatusType>();

  useEffect(() => {
    switch (status) {
      case SystemConstant.STATE.active:
        setBtnStatus({
          color: "primary",
          label: getLabel("OBJ_STATUS_USER.active"),
        });
        break;
      case SystemConstant.STATE.inactive:
        setBtnStatus({
          color: "error",
          label: getLabel("OBJ_STATUS_USER.inactive"),
        });
        break;

      default:
        break;
    }
  }, [status]);

  return (
    btnStatus && (
      <ButtonStatusUser variant="outlined" color={btnStatus.color} disableRipple>
        {btnStatus.label}
      </ButtonStatusUser>
    )
  );
};

export default StatusUser;
